<template>
  <div 
    class="yunxiao teacher add-student-communication-page">
    <div class="main">
      <van-form class="full-page" input-align="right">
        <div :class="{ 'add-disabled': !isAdd }">
          <van-field :disabled="!isAdd" name="radio" label="沟通结果" required>
            <template #input>
              <van-radio-group
                v-model="params.result"
                direction="horizontal"
                :disabled="!isAdd"
              >
                <van-radio :name="1">有效</van-radio>
                <van-radio :name="0">无效</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            :disabled="!isAdd"
            readonly
            clickable
            required
            name="picker"
            v-model="params.typeDesc"
            label="沟通类型"
            :right-icon="'arrow'"
            placeholder="请选择"
            @click.stop="choiceListItem('typeList', '沟通类型')"
          />
          <van-field
            :disabled="!isAdd"
            readonly
            clickable
            name="picker"
            v-model="params.mode"
            label="沟通方式"
            :right-icon="'arrow'"
            placeholder="请选择"
            @click.stop="choiceListItem('modeList', '沟通方式')"
          />

          <van-field
            :disabled="!isAdd"
            readonly
            clickable
            name="picker"
            v-model="params.teacherName"
            label="沟通人"
            :right-icon="'arrow'"
            placeholder="请选择负责沟通跟进的老师"
            @click.stop="choiceTeacher()"
          />
          <van-field
            style="margin: calc(var(--gap) * 20) 0;"
            :disabled="!isAdd"
            readonly
            :clickable="!isAdd"
            name="picker"
            v-model="params.parentName"
            label="沟通对象"
            :right-icon="'arrow'"
            placeholder="请选择"
            @click.stop="choiceRelation"
          />
        </div>

        <van-field style="display: block">
          <template #label>
            <span>沟通内容</span>
          </template>
          <template #input>
            <vx-mult-input v-model="params.content.list"> </vx-mult-input>
          </template>
        </van-field>
        <van-cell title="下次沟通时间" is-link :value="nextTimeFormat || '请选择'" @click="selectNextTime"/>
      </van-form>
    </div>
    <div class="footer">      
      <van-button
        square round
        block
        plain
        @click="deleteCommunication"
        v-if="!isAdd&&app.permission.op('delete_student_communicate')"
        style="margin-right: calc(var(--gap) * 12)"
        data-test="add-communication-page-btn-delete"
        >删除</van-button
      >
      <van-button
        square round
        block
        type="primary"
        @click="submitClue"
        loading-text="保存中..."
        :loading="submiting"
        data-test="add-communication-page-btn-save"
        >保存</van-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: 'addCommunicationPage',
  computed: {
    nextTimeFormat() {
      return this.params.nextTime ? app.tool.date.formatDatetime(new Date(this.params.nextTime), 'yyyy-MM-dd hh:mm') : '';
    }
  },
  data () {
    return {
      pageTitle: '添加沟通记录',
      isAdd: true,
      params: {
        // type:'',
        typeDesc: '',
        mode: '',
        teacherId: app.teacher.user.id,
        teacherName: app.teacher.user.name,
        parentId: '',
        parentName:'',
        nextTime: '',
        // 联系人ID，可能会不存在parentID
        contactsId: '',
        content: {
          list: [
            {
              content: "",
              type: "text",
            },
          ],
        }
      },
      typeList: [
        // 沟通类型
        { id: 0, dictName: "销售转化" },
        { id: 1, dictName: "日常问候" },
        { id: 2, dictName: "售后服务" },
        { id: 3, dictName: "问题答疑" },
        { id: 4, dictName: "家访" },
        { id: 5, dictName: "其他" },
      ],
      modeList: [
        // 沟通方式
        { id: 0, dictName: "微信" },
        { id: 1, dictName: "电话" },
        { id: 2, dictName: "QQ" },
        { id: 3, dictName: "当面" },
        { id: 4, dictName: "其他" },
      ],      
      fromPage: this.$vxRoute.query.fromPage,
      submiting: false,
    }
  },
  methods:{
    selectNextTime(){
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      app.x3.picker
        .datetime({
          type: 'datetime',
          'min-date': new Date(),
          value: this.params.nextTime ? new Date(this.params.nextTime) : tomorrow,
        })
        .then(res => {
          this.params.nextTime = res.getTime();
        });
    },
    choiceListItem(str, title, item) {
      var def = "";
      if (str == "studentStatus") {
        def = item.followStatus;
      } else if (str == "typeList") {
        def = this.params.type;
      }
      app.x3.picker
        .dictionary({
          title: title,
          list: this[str],
          default: def,
        })
        .then((res) => {
          if (str == "studentStatus") {
            item.followStatus = res.id;
            item.followStatusDesc = res.dictName;
          } else if (str == "typeList") {
            this.params.type = res.id;
            this.params.typeDesc = res.dictName;
          } else if (str == "modeList") {
            this.params.mode = res.dictName;
          }
        });
    },
    async choiceTeacher() {
      let res = await app.x3.side.xsTeacher({
        id: this.params.teacherId,
        params: {
          statusList: [1],
        }
      });
      this.params.teacherId = res ? res.id : null;
      this.params.teacherName = res ? res.name : "";
    },
    choiceRelation () {
      if (!this.isAdd) return false;
      app.x3.side
        .xsRelation({
          id: this.params.parentId,
          params: {
            id: this.$vxRoute.query.id,            
            companyId: app.teacher.user.companyId,
          }
        })
        .then((res) => {
          this.params.parentId = res.parentId ? res.parentId : null;
          this.params.parentName = res.relation ? res.relation : "";
          this.params.contactsId = res.contactsId
        });
    },
    addIntentionCommunicate() {
      let params = JSON.parse(JSON.stringify(this.params));
      params.studentId = this.$route.query.id;
      this.submiting = true;
      this.$api
        .addIntentionCommunicate(params)
        .then((res) => {
          if (res.code === 200) {
            this.$toast.success("操作成功");
            app.vue.$emit("refresh-student-communicate-details");
            app.vue.$emit("refresh-student-communicate-list");
            this.$router.back();
          }
        })
        .finally(() => {
          this.submiting = false;
        });
    },
    putIntentionCommunicate() {
      this.isSubmit = true;      
      this.params.studentId = this.$route.query.id;
      this.$api
        .putIntentionCommunicate(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$toast.success("操作成功");            
            app.vue.$emit("refresh-student-communicate-details");
            app.vue.$emit("refresh-student-communicate-list");
            this.$router.back();
          }
        })
        .finally(() => {
          this.isSubmit = false;
        });
    },
    getIntentionCommunicate() {
      return this.$api
        .getStudentCommunicate({
          communicateId: this.detailId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.params = res.data;
            this.params.parentName = res.data.relation;
          }
        });
    },
    submitClue() {
      if (this.params.result == null) {
        this.$toast.fail("请选择沟通结果");
        return;
      }
      if (this.params.type == null) {
        this.$toast.fail("请选择沟通类型");
        return;
      }
      if (this.isAdd) {
        this.addIntentionCommunicate();
      } else {
        this.putIntentionCommunicate();
      }
    },
    deleteCommunication() {
      this.$dialog
        .confirm({
          message: "确定要删除此条沟通记录么？",
        })
        .then(() => {
          this.$api
            .deleteIntentionCommunicate({
              id: this.detailId,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$toast.success("操作成功");
                app.vue.$emit("refresh-student-communicate-list");
                app.vue.$emit("deleted-student-communicate-list");
                this.$router.back();
              }
            });
        })
        .catch(() => {});
    },
  },
  async created() {
    if (this.$route.query.detailId) {
      this.detailId = Number(this.$route.query.detailId);
      this.isAdd = false;
      this.pageTitle = "沟通详情";
      this.showLoading();
      try {
        await this.getIntentionCommunicate();
      } catch (err) {
        console.log(err)
      }
      this.$toast.clear();
      
    }
  },

}
</script>
<style lang="scss" scoped>
.yunxiao.teacher.add-student-communication-page{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow-y: auto;
    .add-disabled {
      position: relative;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
  .footer {
    height: calc(var(--w) * 50);
    background: var(--white);
    padding: calc(var(--gap) * 4) calc(var(--gap) * 16);
    display: flex;
    .van-button {
      height: var(--cl-xs);
    }
  }
}
</style>